import {Globals} from "./Globals";
import {CuppaStorage} from "../../cuppa/cuppa.storage";
import {Storages} from "./Storages";
import {cuppa, log, val} from "../../cuppa/cuppa";
import {Constants} from "./Constants";
import {UserCtrl} from "./UserCtrl";

export class GraphQL{
	static async query({query = null, mutation = null, addRootBrackets = true, printQuery = false, printResult = false,} = {}){
		let headers = {'content-type': 'application/json'};
		let token = await CuppaStorage.getData(Storages.auth);
			if(token?.accessToken){ headers["Authorization"] = "Bearer "+token?.accessToken; }
		let body = {};
			if(query){
				if(addRootBrackets) body.query = `query{${query}}`;
				else body.query = query;
			}
			if(mutation){
				if(addRootBrackets) body.query = `mutation{${mutation}}`;
				else body.query = mutation;
			}
		if(printQuery) console.log(body.query)
		let result;
		let url = `${Globals.apiURL}/graphql/`;
		try{
			result = await fetch(url, {method:'post', body:JSON.stringify(body), headers});
			result = await result.json();
		}catch(err){ result = null; }
		if(val(result, `errors.0.message`) === Constants.TOKEN_NOT_VALID){
			UserCtrl.logOut().then();
		}else if(token?.refreshToken){
			UserCtrl.refreshToken().then();
		}
		if(printResult) log(result);
		return result;
	}
}
